import { render, staticRenderFns } from "./info.vue?vue&type=template&id=ac718bc0&"
import script from "./info.vue?vue&type=script&lang=ts&"
export * from "./info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports